const staticFileBasePath = '/assets/static'

const appConfig: { [key: string]: string } = {
  STUNNR_BE_CLIENT_ID: '496B3A67978342DAAA92C39CEFF8C433',
  LOGO_STORAGE_PATH: `${import.meta.env.VITE_APP_STORAGE_URL}/AllFiles/Uploads/Logos/`,
  bugsnagApiKey: 'e2c4f44f9badd66c394d74c5cd5f2f61',
  APP_LOGO: `${staticFileBasePath}/images/app-logo.svg`,
  PROFILE_SELECTION_ILLUSTRATION_LIGHT: `${staticFileBasePath}/images/select-profile-light.svg`,
  CLIENT_APP: '2',
  NOT_FOUND_DARK: `${staticFileBasePath}/images/not-found-dark.svg`,
  NOT_FOUND_LIGHT: `${staticFileBasePath}/images/not-found-light.svg`
}

export default appConfig
